import React from 'react'
import PropTypes from 'prop-types'
import { Interactions } from 'LiveBoard/components/shared/Interactions'
import { SmartImage } from 'shared/UI/SmartImage'
import { Description } from 'LiveBoard/components/mobile/shared/Item/Description'
import { DummyAnchorTag } from 'LiveBoard/components/shared/DummyAnchorTag'

import './style.css.scss'

const ItemTile = (props) => {
  const {
    item, themeColorHex, onClick, showViews,
    showLikes, showItemDescription, getItemUrl
  } = props
  const { image, name, likes_count, views_count, description } = item

  const handleClick = () => onClick(item.id)
  const itemRoute = !!getItemUrl ? getItemUrl(item.id) : ""

  return (
    <div className="item-tile" onClick={handleClick}>
      <SmartImage
          config={image}
          height={230}
          width={328} />
      <div className="details">
        <div className="title">
          <DummyAnchorTag url={itemRoute}>{name}</DummyAnchorTag>
        </div>
        { showItemDescription && description && (
          <Description text={description} themeColorHex={themeColorHex} />
        )}
        <Interactions
          likesCount={likes_count}
          viewsCount={views_count}
          showViews={showViews}
          showLikes={showLikes} />
      </div>
    </div>
  )
}

ItemTile.propTypes = {
  item: PropTypes.object.isRequired,
  themeColorHex: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  showViews: PropTypes.bool,
  showLikes: PropTypes.bool,
  showItemDescription: PropTypes.bool,
  getItemUrl: PropTypes.func
}

export default ItemTile